import React from 'react';
import { Col } from 'react-bootstrap';

const FormCol2 = props => (
  <Col sm={6} lg={2} xl={2} {...props}>
    {props.children}
  </Col>
);

export default FormCol2;

